/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:07:09
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsyDateTime from '../../BsyDateTime';
import BsyDateTimeLimit from '../../BsyDateTimeLimit';
import BsyDateTimeRange from '../../BsyDateTimeRange';
import BsySelect from '../../BsySelect';
import BsyTimePicker from '../../BsyTimePicker';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';
import { dayjsUtils } from '../../../utils/dayjsUtils';

export class BsyFilterDate extends BsyFilterBase {

    DEFAULT_SIZE = {
        single: {
            minSizeX: 15,
            minSizeY: 6
        },
        double: {
            minSizeX: 10,
            minSizeY: 8
        },
        custom: {
            minSizeX: 10,
            minSizeY: 6
        }
    }

    VIEW_MODE = {
        CAL: 1,
        LIM: 2
    }

    constructor(props) {
        super({
            customCls: "fui_dash_date",
            minRow: 8,
            minCol: 10,
            calendarMinCol: 20,
            calendarDateMinRow: 22,
            calendarDateTimeMinRow: 24,
            onStopEdit: null,
            ...props
        })
        this.state = {
            ...this.state,
            showTimePack: false
        }
        let i = this.options;
        switch (i.type) {
            case 'datetime_filter': {
                i.format = "yyyy-MM-dd HH:mm:ss"
                break;
            }
            case 'date_filter': {
                i.format = "yyyy-MM-dd"
                break;
            }
            case 'datemonth_filter': {
                i.format = "yyyy-MM"
                break;
            }
            case 'dateyear_filter': {
                i.format = "yyyy"
                break;
            }
            default: {
                i.format = "yyyy-MM-dd"
            }
        }
        this.dashDate = null;
    }


    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.EQ,
        BsyConfig().CONST.FILTER_METHOD.NE,
        BsyConfig().CONST.FILTER_METHOD.GTE,
        BsyConfig().CONST.FILTER_METHOD.LTE,
        BsyConfig().CONST.FILTER_METHOD.RG,
        BsyConfig().CONST.FILTER_METHOD.FM,
        BsyConfig().CONST.FILTER_METHOD.EP,
        BsyConfig().CONST.FILTER_METHOD.NEP]

    }

    _getDateItems = () => {
        return [{
            text: React.language("today"),
            value: "today"
        }, {
            text: React.language("date.yesterday"),
            value: "yesterday"
        }, {
            text: React.language("date.thisWeek"),
            value: "thisWeek"
        }, {
            text: React.language("last.seven.day"),
            value: "last7day"
        }, {
            text: React.language("date.lastWeek"),
            value: "lastWeek"
        }, {
            text: React.language("date.thisMonth"),
            value: "thisMonth"
        }, {
            text: React.language("date.lastMonth"),
            value: "lastMonth"
        },
        { //2022 02 12预留代码 bobo 后端暂没有做功能实现
            text: React.language("date.thisYear"),
            value: "thisYear"
        }, {
            text: React.language("date.lastYear"),
            value: "lastYear"
        },
        {
            text: React.language("custom"),
            value: "custom"
        }]
    }

    setValue = (t, method) => {
        this.value = t || {};

        if (method)
            this.method = method || this.options.method;
        let val = this.getMiddleValue()
        let showTimePack = false;
        if (val) {
            if (val.mode === 'custom') {
                showTimePack = true;
            }
        }
        this.setState({ showTimePack })
    }
    getValue = () => {
        let e = this;
        if (this.dashDate) {

            switch (e.method) {
                case BsyConfig().CONST.FILTER_METHOD.RG:
                    const realValue = this.dashDate.getRealValue();
                    return realValue;
                case BsyConfig().CONST.FILTER_METHOD.FM:
                    var t = this.dashDate.getValue();

                    let r = {
                        mode: "preset",
                        formula: t
                    }
                    if ("custom" === t) {
                        r = {
                            mode: t,
                            formula: this.dashDatetime ? this.dashDatetime.getValue() : null
                        }
                    }

                    return r;

                case BsyConfig().CONST.FILTER_METHOD.EQ:
                case BsyConfig().CONST.FILTER_METHOD.NE:
                case BsyConfig().CONST.FILTER_METHOD.GTE:
                case BsyConfig().CONST.FILTER_METHOD.LTE:
                    let val = this.dashDate.getRealValue()
                    return {
                        value: val
                    };
                default:
                    return null
            }

        }
        return null
    }

    getContext = (e) => {
        this.dashDate = e;
    }

    getDateContext = (e) => {
        this.dashDatetime = e;
    }

    //由于React数据 驱动机制
    getMiddleValue = () => {
        return this.value
        // if (this.dashDate || this.dashDatetime) {
        //     return this.value
        // }
        // return this.options.defaultConfig
    }


    _getViewMode = () => {
        var t = this.options;
        return t.width >= t.calendarMinCol ? t.format && t.format.match(/[YyDd]/) && t.format.match(/[Hh]/) ? t.height > t.calendarDateTimeMinRow ? this.VIEW_MODE.CAL : this.VIEW_MODE.LIM : t.height > t.calendarDateMinRow ? this.VIEW_MODE.CAL : this.VIEW_MODE.LIM : this.VIEW_MODE.LIM
    }

    renderCont = () => {
        var e = this
            , i = this.options;
        let val = this.getMiddleValue(); //BsyUtils.isObjectEmpty(e.state.value) ? this.options.defaultConfig : e.state.value;
        let { showTimePack } = this.state;
        if (!this.dataIndex) {
            this.dataIndex = 0;
        }
        this.dataIndex++;
        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.RG:
                this.viewMode = this._getViewMode()

                if (typeof val.min === 'string') {
                    const object = dayjsUtils.timeToLocal(new Date(val.min));
                    val.min = object.date.getTime();
                }
                if (typeof val.max === 'string') {
                    const object = dayjsUtils.timeToLocal(new Date(val.max));
                    val.max = object.date.getTime();
                }

                switch (this.viewMode) {
                    case this.VIEW_MODE.CAL:
                        return <BsyDateTimeRange
                            key={"BsyDateTimeRange" + new Date().getTime()}
                            value={val}
                            width={'100%'}
                            theme={this.props.theme}
                            format={i.format ? i.format : 'yyyy-MM-dd'}
                            width4number={'auto'}
                            onStopEdit={e1 => {
                                e.value = e.getValue()
                                BsyUtils.applyFunc(e, i.onStopEdit, [{
                                    value: e.getValue(),
                                    valueMode: e.valueMode,
                                    method: e.method,
                                }, i], !1)
                            }}
                            getContext={this.getContext}
                        ></BsyDateTimeRange>

                    case this.VIEW_MODE.LIM:
                    default:
                        return <BsyDateTimeLimit
                            key={"BsyDateTimeLimit" + new Date().getTime()}
                            value={val}
                            width={'100%'}
                            height={'auto'}
                            theme={this.props.theme}
                            format={i.format ? i.format : 'yyyy-MM-dd'}
                            customCls={i.height > i.minRow ? "wrap" : ""}
                            style={this.style}
                            width4number={'auto'}
                            onStopEdit={e1 => {
                                e.value = e.getValue()
                                BsyUtils.applyFunc(e, i.onStopEdit, [{
                                    value: e.getValue(),
                                    valueMode: e.valueMode,
                                    method: e.method,
                                }, i], !1)
                            }}
                            getContext={this.getContext}
                        >
                        </BsyDateTimeLimit>
                }

            case BsyConfig().CONST.FILTER_METHOD.FM:
                if (Array.isArray(val)) {
                    val = val[0];
                }
                if (val && val.mode === 'custom') {
                    showTimePack = true;
                }
                return <div className={'custom format ' + (i.height > i.minRow ? "wrap" : "")}>
                    <BsySelect
                        allowBlank={false}
                        searchable={false}
                        theme={this.props.theme}
                        width="auto"
                        height={'34px'}
                        onStopEdit={e1 => {

                            let r = {
                                mode: "preset",
                                formula: e1
                            }
                            if ("custom" === e1) {
                                r = {
                                    mode: e1,
                                    formula: null
                                }
                            }
                            e.options.defaultConfig = r;
                            e.value = r;
                            this.setState({
                                showTimePack: e1 === 'custom',
                            }, () => {
                                e.value = e.getValue()
                                BsyUtils.applyFunc(e, i.onStopEdit, [{
                                    value: e.getValue(),
                                    valueMode: e.valueMode,
                                    method: e.method,
                                }, i], !1)
                            })


                        }}
                        value={val && (val.mode === "preset" ? val.formula : val.mode)}
                        items={this._getDateItems()}
                        getContext={this.getContext}
                    />
                    {
                        showTimePack && <BsyTimePicker
                            width="auto"
                            theme={this.props.theme}
                            height={34}
                            onStopEdit={e1 => {
                                e.value = e.getValue()
                                BsyUtils.applyFunc(e, i.onStopEdit, [{
                                    value: e.getValue(),
                                    valueMode: e.valueMode,
                                    method: e.method,
                                }, i], !1)
                            }}
                            value={val ? val.formula : null}
                            getContext={this.getDateContext}
                        />
                    }
                </div>

            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.NE:
            case BsyConfig().CONST.FILTER_METHOD.GTE:
            case BsyConfig().CONST.FILTER_METHOD.LTE:
                if (typeof val.value === 'string') {
                    const object = dayjsUtils.timeToLocal(new Date(val.value));
                    val.value = object.date.getTime();
                }

                return <BsyDateTime
                    theme={this.props.theme}
                    key={"date" + this.dataIndex}
                    value={!val.value ? null : new Date(val.value)}
                    format={i.format ? i.format : 'yyyy-MM-dd'}
                    style={this.style}
                    getContext={this.getContext}
                    onStopEdit={e1 => {
                        e.value = e.getValue()
                        BsyUtils.applyFunc(e, i.onStopEdit, [{
                            value: e.getValue(),
                            valueMode: e.valueMode,
                            method: e.method,
                        }, i], !1)
                    }}
                >
                </BsyDateTime>

            default:
        }
    }

    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

